import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Chrome = () => {
  const data = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "chrome.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img className="install-icon" fluid={data.image.childImageSharp.fluid} />
  )
}

export default Chrome
